export const BERTH_DIMENSIONS = {
  MIN_HEIGHT: 32,
  MIN_WIDTH: 160,
  MAX_WIDTH: 500,
}
